module.exports = __webpack_public_path__ + "img/logo-aqua-2.0d0d4a77.jpg";